/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EsercenteImportazioneCandidataDTO } from './esercente-importazione-candidata-dto';


export interface EsercenteImportazioneCandidateDTO { 
    candidate?: Array<EsercenteImportazioneCandidataDTO>;
    totale?: number;
    importabili?: number;
    importabili_con_dichiarazioni?: number;
}

